import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAKUPuH0w7Fvkq9EFwDaJQAdy-I8ZsPZ4Y",
  authDomain: "recipes-firebase-b0d60.firebaseapp.com",
  databaseURL: "https://recipes-firebase-b0d60-default-rtdb.firebaseio.com",
  projectId: "recipes-firebase-b0d60",
  storageBucket: "recipes-firebase-b0d60.firebasestorage.app",
  messagingSenderId: "675614320015",
  appId: "1:675614320015:web:b7c20a02b59011121257fa"
};

const app = initializeApp(firebaseConfig);

export const auth    = getAuth(app);
export const db      = getDatabase(app);
export const storage = getStorage(app);
export default app;
